import superagent from "superagent";
import { API_URL } from "./base";

export function CreateUserSession(email, password) {
  const URL = `/${I18n.locale}/user/sessions`;
  const payload = {
    user: {
      email: email,
      password: password,
    },
  };

  return new Promise((resolve, reject) => {
    superagent
      .post(URL)
      .send(payload)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}

export function RegisterUser(userData) {
  const URL = `/${I18n.locale}/user/registrations`;
  const payload = { user: userData };

  return new Promise((resolve, reject) => {
    superagent
      .post(URL)
      .send(payload)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}

export function RequestPasswordToken(email) {
  const URL = `${API_URL}/users/reset_password`;
  const payload = { email: email };

  return new Promise((resolve, reject) => {
    superagent
      .post(URL)
      .send(payload)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}

export function ChangePassword(password, reset_password_token) {
  const URL = `${API_URL}/users/password`;
  const payload = {
    user_password: {
      reset_password_token,
      password,
      confirmation: password,
    },
  };

  return new Promise((resolve, reject) => {
    superagent
      .put(URL)
      .send(payload)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}

export function updateUser(user, token) {
  const URL = `${API_URL}users/me`;

  const payload = user;
  const tokenAuth = `Token token=${token}`;

  return new Promise((resolve, reject) => {
    superagent
      .put(URL)
      .set("Authorization", tokenAuth)
      .send(payload)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}

export async function updatePhone(phone, token) {
  const URL = `${API_URL}users/phone`;
  const tokenAuth = `Token token=${token}`;

  return new Promise((resolve, reject) => {
    superagent
      .put(URL)
      .set("Authorization", tokenAuth)
      .send(phone)
      .set("Accept", "application/json")
      .end((err, res) => {
        let apiErrors = res?.body?.errors?.number || []
        if (err && Array.isArray(apiErrors)) {
          if (apiErrors.some(e => {
            return e?.error || "" === "taken"
          })) {
            reject("taken")
          }
        }
        err ? reject(err) : resolve(res.body.result);
      });
  })
}

export function getUserDetails(token) {
  const URL = `${API_URL}users/me`;
  const tokenAuth = `Token token=${token}`;

  return new Promise((resolve, reject) => {
    superagent
      .get(URL)
      .set("Authorization", tokenAuth)
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(error) : resolve(res.body.result);
      });
  });
}
